import {
   MedicalServicePerformableByPractitionerSimple,
   MedicalServicePerformableByPractitionerSimpleQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';
import {
   AutosuggestItemRenderer,
   AutosuggestLabelExtractor,
   AutosuggestSearchCreator,
   KeyExtractorRendererKeyExtractor,
   Text,
   TextSeparator,
   TextSeparatorType,
} from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

import { StyledPrice } from './InvoiceItemsTableMedicalServiceNameCell.styled';

export const medicalServiceItemRenderer: AutosuggestItemRenderer<MedicalServicePerformableByPractitionerSimple> = (
   item
) => {
   return (
      <TextSeparator separator={TextSeparatorType.SPACE}>
         <Text testId={'name'}>{item.name}</Text>
         <StyledPrice testId={'price'} whiteSpaces={'nowrap'}>
            {priceFormatter(
               item.price.asNumber(),
               getCustomFormattingContext({
                  options: {
                     currency: 'PLN',
                     stripDecimalZeroes: false,
                  },
               })
            )}
         </StyledPrice>
      </TextSeparator>
   );
};

export const medicalServiceSearchCreator = (
   practitionerId?: PractitionerId
): AutosuggestSearchCreator<MedicalServicePerformableByPractitionerSimple> => {
   return (searchText) => {
      return async (): CqrsQueryPerformResult<MedicalServicePerformableByPractitionerSimple[]> =>
         performCqrsQuerySearch<MedicalServicePerformableByPractitionerSimple>(() => {
            const query = new MedicalServicePerformableByPractitionerSimpleQuery();
            if (practitionerId) {
               query.practitionerId = practitionerId?.asNumber();
            }
            if (searchText) {
               query.name = TextPattern.anywhereIgnoreCase(searchText);
            }

            return query;
         }, paginations.all<MedicalServicePerformableByPractitionerSimple>().orderedBy('name', paginations.Direction.ASCENDING));
   };
};

export const medicalServiceTextInputValueExtractor: AutosuggestLabelExtractor<MedicalServicePerformableByPractitionerSimple> = (
   item
) => `${item.name}`;

export const medicalServiceKeyExtractor: KeyExtractorRendererKeyExtractor<MedicalServicePerformableByPractitionerSimple> = (
   item
) => item.medicalServiceId;
